module.exports = __webpack_public_path__ + "img/IMG_1971.c55f8005.jpg";